import styled from 'styled-components';

// eslint-disable-next-line rulesdir/no-styled-export
export const RequestTypeDescription = styled.span`
    p {
        /* We want any rendered <p>'s to be display inline so it correctly shows ellipsis. */
        display: inline;
    }
`;
